import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import "./style.css";

const Separator = ({ slim }) => (
  <div className={cx("separator", { "separator--slim": slim })}>
    <div className="separator__center" />
  </div>
);

Separator.propTypes = {
  slim: PropTypes.bool
};

Separator.defaultProps = {
  slim: false
};

export default Separator;



// WEBPACK FOOTER //
// ./src/components/Separator/index.js